import React from 'react';
import { I18n, Trans } from 'react-i18next';
import $ from 'jquery';

export class Flag extends React.Component {


  render() {
    return (
       <I18n ns="translations">
        {
          (t, { i18n }) => { 
            
            var en_css_class = "";
            var fr_css_class = "";
            
            if(i18n.language == "en") {
              en_css_class="flag-active";
            }

            if(i18n.language == "fr") {
              fr_css_class="flag-active";
            }


            return (<div>
                  <ul className="flag" >
                      <li className={fr_css_class} onClick={(e) => {i18n.changeLanguage('fr'); $('.flag li').removeClass('flag-active');$(e.target).addClass('flag-active'); }}>
                        <img src="../../images/menu_drapeau_fr.png" />Français
                      </li>
                      <li className={en_css_class} onClick={(e) => {i18n.changeLanguage('en'); $('.flag li').removeClass('flag-active'); $(e.target).addClass('flag-active');} }>
                        <img src="../../images/menu_drapeau_eng.png" />English
                      </li>
                  </ul>
                  <div className="btm-logo pull-right">
                   <img src="../../images/logo_btm.png"/>
                  </div>
             </div>
             );

          }
         }
     </I18n>
     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav/Flag.js